// App Version - Update this when deploying new version
export const APP_VERSION = "3.5.0";
export const APP_BUILD_DATE = "2026-01-20";

// Changelog
export const CHANGELOG = {
  "3.5.0": [
    "🏀 Team Builder für Trainings",
    "⚖️ Faire Teams nach Größe, Gewicht, Position, OCE",
    "✅ Kriterien wählbar (Mehrfachauswahl)",
    "👤 Admin kann Spieler hinzufügen/entfernen",
    "🔄 Neu mischen Button"
  ],
  "3.4.0": [
    "📝 Profil-Vervollständigung beim Start (Größe, Gewicht, Position, E-Mail)",
    "👤 Nutzer können eigene Profildaten in Einstellungen bearbeiten",
    "🔄 Modal erscheint bis alle Daten komplett sind"
  ],
  "3.3.6": [
    "👤 Admin: Login-Name (z.B. daniell) sichtbar & editierbar",
    "🏷️ Login-Name wird als Badge in Benutzerliste angezeigt",
    "⚠️ Warnung bei Login-Änderung"
  ],
  "3.3.5": [
    "👤 Admin: E-Mail/Login editierbar",
    "⚠️ Warnung bei E-Mail-Änderung"
  ],
  "3.3.4": [
    "🖼️ AI-Bilder laden jetzt korrekt (beide Collections)",
    "⚡ Lazy-Loading für Bilder (bessere Performance)",
    "🔧 Backend sucht in chat_image_chunks UND image_chunks"
  ],
  "3.3.3": [
    "🖼️ AI-Bilder Fix: Lädt jetzt aus beiden Collections",
    "🔍 Besseres Logging für Bild-Debugging"
  ],
  "3.3.2": [
    "📷 Foto-Upload: Chunked Storage für große Bilder",
    "🔄 Bilder-Cache: Bessere Performance, kein Neuladen",
    "📍 Chat springt zur ersten ungelesenen Nachricht",
    "🔔 Push-Status zeigt korrekten Status (aktiv/inaktiv)"
  ],
  "3.3.1": [
    "🔔 Push-Notification Debug - Fix für Subscription-Speicherung",
    "🔍 Detailliertes Logging für Push-Probleme",
    "✅ Auto-Re-Subscription wenn Backend-Eintrag fehlt"
  ],
  "3.3.0": [
    "👥 +1 Gast beim Training - Freunde mitbringen",
    "⏰ Kiosk Auto-Close nach 30 Min Inaktivität",
    "🚫 Kiosk schließt bei <3 Spielern automatisch"
  ],
  "3.2.0": [
    "😀 Emoji-Picker mit Suche und Kategorien",
    "👍 Emoji-Reaktionen auf Nachrichten",
    "🔔 Push-Benachrichtigung bei App-Start abfragen",
    "📲 Chat-Shortcut Installation beim Start",
    "📊 Hinrunde komplett: 6-5 (780:756)",
    "🖼️ Chat-Bilder werden gecached",
    "🧹 Duplikate und Stats bereinigt"
  ],
  "3.1.0": [
    "🎨 DALL-E 3 HD - Hochwertigere Bildgenerierung",
    "✏️ Bilder bearbeiten - Bestehende Bilder mit Prompt verändern",
    "🔍 Galerie-Suche nach Personen",
    "🤖 Gesichtserkennung - Automatisches Taggen",
    "✅ Grüner Haken bei gespeicherten Bildern",
    "🔔 Push-Notifications verbessert",
    "📱 Chat-Shortcut immer installierbar"
  ],
  "3.0.1": [
    "🎨 Komplettes UI/UX Redesign aller Seiten",
    "💬 Chat mit AI-Bildgenerierung (DALL-E 3)",
    "🖼️ Galerie mit 'Aus Chat speichern' Funktion",
    "⏰ Kiosk: 30 Min Inaktivitäts-Timeout",
    "🔔 Chat-Notifications mit Desktop-Toggle",
    "📱 Chat als Desktop-Shortcut installierbar"
  ],
  "2.0.0": [
    "🎉 Kiosk v2.0 - KEIN GPS mehr!",
    "👥 Session startet bei 3 Spielern (nicht 2)",
    "🚨 Katastrophen-Alarm für ALLE User",
    "⏰ Inaktivitäts-Tracking mit 'Bin noch da'",
    "🚿 Duschgel MVP - Stündliche Benachrichtigungen",
    "🔔 Notifications immer aktiv (kein Toggle mehr)"
  ],
  "1.3.4": [
    "🔧 Kiosk Race Conditions behoben",
    "🔒 Firebase Rules korrigiert",
    "💪 Transaction-basiertes Join"
  ],
  "1.3.3": [
    "🔓 Admin-Override für MVP-Testing",
    "⏰ MVP bleibt bei 30 Minuten (Production-Ready)"
  ],
  "1.3.2": [
    "🎯 Kiosk GPS-Fix: Radius 30m → 200m",
    "📡 Bessere Kompatibilität mit Desktop-Browsern"
  ],
  "1.3.1": [
    "🔢 OCE v2.0 - Neue fairere Berechnung",
    "📊 Blowout-Korrektur für Plus/Minus",
    "🎯 Freiwurf-Faktor (70% ist neutral)",
    "🔥 Aggressivitäts-Bonus für Fouls",
    "⚖️ Presence-Multiplier für längere Einsatzzeiten",
    "📘 Glossar komplett überarbeitet"
  ],
  "1.3.0": [
    "🚿 Dusch-Gel MVP Award - Voting nach jedem Event",
    "📋 Profil-Pflichtfelder (Größe, Gewicht, Position)",
    "🔔 Event-Erinnerungen (4h/3h/2h/1h vorher)",
    "🎭 Rollen-System (Fan, Sparringspartner, Spieler, Admin)",
    "📊 Statistiken-Fix: nur existierende Events zählen",
    "🍕 Pizza Pazza im Kiosk",
    "🔄 Kiosk-Reset Funktion",
    "✨ Benachrichtigungsbutton verbessert"
  ]
};
